import { Box, Image, Menu, MenuButton, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { FiRepeat } from "react-icons/fi";
import { QtyStepper } from "../QtyStepper";
import { CASE_BASE_UNIT_LABEL } from "../constants";

function money(value) {
  return Number(value).toLocaleString("pt-br", { style: "currency", currency: "BRL" });
}

// Correction C6: the [-][+] here always controls the item's STEPPABLE unit —
// case_quantity (caixas) for sale_mode "case", quantity (barris/garrafas)
// otherwise — never raw units, and the price line always makes clear which
// unit is being priced ("R$ X a unidade · R$ Y a caixa").
export function SuggestedItemRow({ result, item, quantity, onChange, alternatives, onSwap }) {
  const unitPrice = Number(item.unit_price);
  const stepPrice = item.sale_mode === "case" ? Number(item.case_price) : unitPrice;
  const subtotal = money(stepPrice * quantity);
  const canSwap = quantity > 0 && alternatives && alternatives.length > 0;

  let detail;
  if (item.sale_mode === "barrel") {
    detail = `Barril de ${(item.unit_volume_ml / 1000).toLocaleString("pt-br")} L · ${money(unitPrice)} cada`;
  } else if (item.sale_mode === "case") {
    const words = CASE_BASE_UNIT_LABEL[result.key];
    const unitWord = words ? (item.units_per_case === 1 ? words.singular : words.plural) : "unidades";
    detail = `Caixa com ${item.units_per_case} ${unitWord} · ${money(unitPrice)} a unidade · ${money(item.case_price)} a caixa`;
  } else {
    detail = `${money(unitPrice)} cada`;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="10px"
      py="8px"
      borderBottom="1px solid rgba(0,74,51,0.06)"
    >
      <Image
        src={item.photo_url || require("../../../assets/images/placeholder.webp")}
        alt={item.product_name}
        boxSize="40px"
        objectFit="contain"
        borderRadius="8px"
        bg="rgba(0,74,51,0.04)"
        flexShrink={0}
      />

      <Box flex="1" minW={0}>
        <Text fontSize="12px" fontWeight="700" color="#004a33" noOfLines={1}>
          {item.product_name}
          {!item.in_stock && (
            <Text as="span" fontSize="10px" fontWeight="700" color="gray.400" ml="6px">
              · sem estoque
            </Text>
          )}
        </Text>
        <Text fontSize="11px" color="gray.500" noOfLines={1}>
          {detail}
        </Text>
        {canSwap && (
          <Menu placement="bottom-start">
            <MenuButton
              fontSize="11px"
              fontWeight="700"
              color="#fc8f04"
              display="flex"
              alignItems="center"
              gap="3px"
              mt="2px"
              _hover={{ textDecoration: "underline" }}
            >
              <FiRepeat size={11} /> Trocar produto
            </MenuButton>
            <MenuList fontSize="13px" minW="260px" zIndex="10" maxH="320px" overflowY="auto">
              {alternatives.map((alt) => {
                const outOfStock = alt.previewQty === 0;
                return (
                  <MenuItem
                    key={alt.batch_id}
                    onClick={() => onSwap(item.batch_id, alt.batch_id)}
                    isDisabled={outOfStock}
                    opacity={outOfStock ? 0.5 : 1}
                  >
                    <Box>
                      <Text fontWeight="700" color="#004a33" noOfLines={1}>
                        {alt.product_name}
                      </Text>
                      <Text fontSize="11px" color="gray.500">
                        {outOfStock
                          ? "Sem estoque suficiente"
                          : `fica ${alt.previewQty} × ${money(alt.sale_mode === "case" ? alt.case_price : alt.unit_price)} = ${money(alt.previewSubtotal)}`}
                      </Text>
                    </Box>
                  </MenuItem>
                );
              })}
            </MenuList>
          </Menu>
        )}
      </Box>

      <Text fontSize="12px" fontWeight="800" color="#fc8f04" flexShrink={0} whiteSpace="nowrap" textAlign="right">
        {subtotal}
      </Text>

      <QtyStepper value={quantity} onChange={onChange} min={0} max={item.remaining_stock} />
    </Box>
  );
}
